import { Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import Page404 from "../../../Page404/Page403";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  selectUserData,
  selectUserToken,
  setIsLoading,
} from "../../../../features/userSlice";
import { MetaEntitiesEndPointLogic } from "../../../../logic/Admin/MetaEntities/MetaEntitiesEndPointLogic";
import { CollectionMethodsTable } from "./CollectionMethodsTable/CollectionMethodsTable";
import CollectionMethodsFilterCard from "./CollectionMethodsFilter/CollectionMethodsFilterCard";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import SimpleBackdrop from "../../../BackDrop/BackDrop";

const CollectionMethods = () => {
  const oauthTokenHeader = useSelector(selectUserToken) as any;
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const response = useSelector(selectUserData);
  const hasViewCollectionMethodsPermission = CheckPermissions(
    response?.data?.products?.admin,
    "meta_entities",
    "view_collection_methods"
  );

  useEffect(() => {
    const fetchMetaEntitiesFormatTypes = async () => {
      setIsLoading(true);
      setLoading(true);
      try {
        await MetaEntitiesEndPointLogic.getMetaCollectionMethods(
          oauthTokenHeader,
          dispatch
        );
      } catch (error) {
        console.error("Error fetching Meta Entities:", error);
      } finally {
        setIsLoading(false);
        setLoading(false);
      }
    };
    if (oauthTokenHeader) {
      fetchMetaEntitiesFormatTypes();
    }
  }, [oauthTokenHeader, dispatch]);

  if (!hasViewCollectionMethodsPermission) {
    return <Page404 />;
  }

  return (
    <>
      {loading ? (
        <SimpleBackdrop />
      ) : (
        <>
          <Paper
            sx={{
              boxShadow: "none",
              padding: "8px 16px 0px",
              borderEndEndRadius: "0px",
              borderBottomLeftRadius: "0px",
            }}
          >
            <Typography fontSize={24}>Collection Methods List</Typography>
            <CollectionMethodsFilterCard />
          </Paper>
          <Paper
            sx={{
              boxShadow: "none",
              borderTopLeftRadius: "0px",
              borderTopRightRadius: "0px",
            }}
          >
            <CollectionMethodsTable />
          </Paper>
        </>
      )}
    </>
  );
};

export default CollectionMethods;
